/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type AppSessionLoaderFragment = {
  readonly __typename: "AppSession";
  readonly id: c.AppSessionId;
  readonly canEdit: boolean;
  readonly lastRunStart: c.DateTimeString | null;
  readonly snapshot: boolean;
  readonly parameterized: boolean;
  readonly savedView: {
    readonly __typename: "SavedView";
    readonly id: c.SavedViewId;
    readonly name: string;
  } | null;
  readonly hexVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly version: c.HexVersionString;
    readonly logicSessionId: c.AppSessionId;
    readonly hexId: c.HexId;
    readonly canEdit: boolean;
    readonly published: boolean;
    readonly prerunApp: boolean;
    readonly cellsUsedInApp: ReadonlyArray<{
      readonly __typename: "Cell";
      readonly id: c.CellId;
      readonly cellType: Types.CellType;
    }>;
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly cacheDefaultAppState: boolean;
      readonly autoRerun: boolean;
    };
  };
};

export type RunHexWithParamsMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  version: Types.Scalars["HexVersionString"]["input"];
  savedViewId: Types.InputMaybe<Types.Scalars["SavedViewId"]["input"]>;
  preview: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  paramValues: Types.InputMaybe<Types.Scalars["JSONObject"]["input"]>;
  sessionStates: Types.InputMaybe<Types.Scalars["JSONObject"]["input"]>;
  disableAppSessionReuse: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
}>;

export type RunHexWithParamsMutation = {
  readonly __typename: "Mutation";
  readonly runHexVersionWithParams: {
    readonly __typename: "AppRunResult";
    readonly isReusingAppSession: boolean;
    readonly createdFromSavedViewId: c.SavedViewId | null;
    readonly notFoundParams: ReadonlyArray<string>;
    readonly appSession: {
      readonly __typename: "AppSession";
      readonly id: c.AppSessionId;
      readonly canEdit: boolean;
      readonly lastRunStart: c.DateTimeString | null;
      readonly snapshot: boolean;
      readonly parameterized: boolean;
      readonly hexVersion: {
        readonly __typename: "HexVersion";
        readonly id: c.HexVersionId;
        readonly version: c.HexVersionString;
        readonly logicSessionId: c.AppSessionId;
        readonly hexId: c.HexId;
        readonly canEdit: boolean;
        readonly published: boolean;
        readonly prerunApp: boolean;
        readonly defaultAppSessionForViewer: {
          readonly __typename: "DefaultAppSessionForViewer";
          readonly defaultAppSessionId: c.AppSessionId | null;
        };
        readonly cellsUsedInApp: ReadonlyArray<{
          readonly __typename: "Cell";
          readonly id: c.CellId;
          readonly cellType: Types.CellType;
        }>;
        readonly hex: {
          readonly __typename: "Hex";
          readonly id: c.HexId;
          readonly cacheDefaultAppState: boolean;
          readonly autoRerun: boolean;
        };
      };
      readonly savedView: {
        readonly __typename: "SavedView";
        readonly id: c.SavedViewId;
        readonly name: string;
      } | null;
    };
    readonly hex: {
      readonly __typename: "Hex";
      readonly id: c.HexId;
      readonly title: string;
    };
    readonly invalidParams: ReadonlyArray<{
      readonly __typename: "ParamParseError";
      readonly paramName: string;
      readonly paramValue: string;
      readonly inputCellType: string;
      readonly dataType: string;
      readonly appSessionId: c.AppSessionId;
    }>;
  };
};

export type GetAppSessionForAppSessionLoaderQueryVariables = Types.Exact<{
  appSessionId: Types.Scalars["AppSessionId"]["input"];
}>;

export type GetAppSessionForAppSessionLoaderQuery = {
  readonly __typename: "Query";
  readonly appSessionById: {
    readonly __typename: "AppSession";
    readonly id: c.AppSessionId;
    readonly canEdit: boolean;
    readonly lastRunStart: c.DateTimeString | null;
    readonly snapshot: boolean;
    readonly parameterized: boolean;
    readonly savedView: {
      readonly __typename: "SavedView";
      readonly id: c.SavedViewId;
      readonly name: string;
    } | null;
    readonly hexVersion: {
      readonly __typename: "HexVersion";
      readonly id: c.HexVersionId;
      readonly version: c.HexVersionString;
      readonly logicSessionId: c.AppSessionId;
      readonly hexId: c.HexId;
      readonly canEdit: boolean;
      readonly published: boolean;
      readonly prerunApp: boolean;
      readonly cellsUsedInApp: ReadonlyArray<{
        readonly __typename: "Cell";
        readonly id: c.CellId;
        readonly cellType: Types.CellType;
      }>;
      readonly hex: {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly cacheDefaultAppState: boolean;
        readonly autoRerun: boolean;
      };
    };
  };
};

export type AppSessionCreateProjectViewMutationVariables = Types.Exact<{
  hexId: Types.Scalars["HexId"]["input"];
  hexVersionId: Types.Scalars["HexVersionId"]["input"];
  appSessionId: Types.Scalars["AppSessionId"]["input"];
  isSnapshot: Types.Scalars["Boolean"]["input"];
  isLogicView: Types.Scalars["Boolean"]["input"];
  isNotionEmbed: Types.Scalars["Boolean"]["input"];
  appSessionSpecified: Types.Scalars["Boolean"]["input"];
  parameterized: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  inAppReferrer: Types.InputMaybe<Types.PublishedAppViewInAppReferrer>;
  inAppReferrerSource: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type AppSessionCreateProjectViewMutation = {
  readonly __typename: "Mutation";
  readonly createProjectView: {
    readonly __typename: "ProjectView";
    readonly id: c.ProjectViewId;
  } | null;
};

export const AppSessionLoaderFragmentDoc = /*#__PURE__*/ gql`
  fragment AppSessionLoaderFragment on AppSession {
    id
    canEdit
    lastRunStart
    snapshot
    parameterized
    savedView {
      id
      name
    }
    hexVersion {
      id
      version
      logicSessionId
      hexId
      canEdit
      published
      prerunApp
      cellsUsedInApp {
        id
        cellType
      }
      hex {
        id
        cacheDefaultAppState
        autoRerun
      }
    }
  }
`;
export const RunHexWithParamsDocument = /*#__PURE__*/ gql`
  mutation RunHexWithParams(
    $hexId: HexId!
    $version: HexVersionString!
    $savedViewId: SavedViewId
    $preview: Boolean
    $paramValues: JSONObject
    $sessionStates: JSONObject
    $disableAppSessionReuse: Boolean
  ) {
    runHexVersionWithParams(
      hexId: $hexId
      version: $version
      savedViewId: $savedViewId
      preview: $preview
      paramValues: $paramValues
      sessionStates: $sessionStates
      disableAppSessionReuse: $disableAppSessionReuse
    ) {
      appSession {
        ...AppSessionLoaderFragment
        hexVersion {
          id
          defaultAppSessionForViewer(savedViewId: $savedViewId) {
            defaultAppSessionId
          }
        }
      }
      hex {
        id
        title
      }
      isReusingAppSession
      createdFromSavedViewId
      notFoundParams
      invalidParams {
        paramName
        paramValue
        inputCellType
        dataType
        appSessionId
      }
    }
  }
  ${AppSessionLoaderFragmentDoc}
`;
export type RunHexWithParamsMutationFn = Apollo.MutationFunction<
  RunHexWithParamsMutation,
  RunHexWithParamsMutationVariables
>;

/**
 * __useRunHexWithParamsMutation__
 *
 * To run a mutation, you first call `useRunHexWithParamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunHexWithParamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runHexWithParamsMutation, { data, loading, error }] = useRunHexWithParamsMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      version: // value for 'version'
 *      savedViewId: // value for 'savedViewId'
 *      preview: // value for 'preview'
 *      paramValues: // value for 'paramValues'
 *      sessionStates: // value for 'sessionStates'
 *      disableAppSessionReuse: // value for 'disableAppSessionReuse'
 *   },
 * });
 */
export function useRunHexWithParamsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RunHexWithParamsMutation,
    RunHexWithParamsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RunHexWithParamsMutation,
    RunHexWithParamsMutationVariables
  >(RunHexWithParamsDocument, options);
}
export type RunHexWithParamsMutationHookResult = ReturnType<
  typeof useRunHexWithParamsMutation
>;
export type RunHexWithParamsMutationResult =
  Apollo.MutationResult<RunHexWithParamsMutation>;
export type RunHexWithParamsMutationOptions = Apollo.BaseMutationOptions<
  RunHexWithParamsMutation,
  RunHexWithParamsMutationVariables
>;
export const GetAppSessionForAppSessionLoaderDocument = /*#__PURE__*/ gql`
  query GetAppSessionForAppSessionLoader($appSessionId: AppSessionId!) {
    appSessionById(appSessionId: $appSessionId) {
      ...AppSessionLoaderFragment
    }
  }
  ${AppSessionLoaderFragmentDoc}
`;

/**
 * __useGetAppSessionForAppSessionLoaderQuery__
 *
 * To run a query within a React component, call `useGetAppSessionForAppSessionLoaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppSessionForAppSessionLoaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppSessionForAppSessionLoaderQuery({
 *   variables: {
 *      appSessionId: // value for 'appSessionId'
 *   },
 * });
 */
export function useGetAppSessionForAppSessionLoaderQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  > &
    (
      | {
          variables: GetAppSessionForAppSessionLoaderQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  >(GetAppSessionForAppSessionLoaderDocument, options);
}
export function useGetAppSessionForAppSessionLoaderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  >(GetAppSessionForAppSessionLoaderDocument, options);
}
export function useGetAppSessionForAppSessionLoaderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAppSessionForAppSessionLoaderQuery,
    GetAppSessionForAppSessionLoaderQueryVariables
  >(GetAppSessionForAppSessionLoaderDocument, options);
}
export type GetAppSessionForAppSessionLoaderQueryHookResult = ReturnType<
  typeof useGetAppSessionForAppSessionLoaderQuery
>;
export type GetAppSessionForAppSessionLoaderLazyQueryHookResult = ReturnType<
  typeof useGetAppSessionForAppSessionLoaderLazyQuery
>;
export type GetAppSessionForAppSessionLoaderSuspenseQueryHookResult =
  ReturnType<typeof useGetAppSessionForAppSessionLoaderSuspenseQuery>;
export type GetAppSessionForAppSessionLoaderQueryResult = Apollo.QueryResult<
  GetAppSessionForAppSessionLoaderQuery,
  GetAppSessionForAppSessionLoaderQueryVariables
>;
export const AppSessionCreateProjectViewDocument = /*#__PURE__*/ gql`
  mutation AppSessionCreateProjectView(
    $hexId: HexId!
    $hexVersionId: HexVersionId!
    $appSessionId: AppSessionId!
    $isSnapshot: Boolean!
    $isLogicView: Boolean!
    $isNotionEmbed: Boolean!
    $appSessionSpecified: Boolean!
    $parameterized: Boolean
    $inAppReferrer: PublishedAppViewInAppReferrer
    $inAppReferrerSource: String
  ) {
    createProjectView(
      hexId: $hexId
      hexVersionId: $hexVersionId
      appSessionId: $appSessionId
      isSnapshot: $isSnapshot
      isLogicView: $isLogicView
      isNotionEmbed: $isNotionEmbed
      appSessionSpecified: $appSessionSpecified
      parameterized: $parameterized
      inAppReferrer: $inAppReferrer
      inAppReferrerSource: $inAppReferrerSource
    ) {
      id
    }
  }
`;
export type AppSessionCreateProjectViewMutationFn = Apollo.MutationFunction<
  AppSessionCreateProjectViewMutation,
  AppSessionCreateProjectViewMutationVariables
>;

/**
 * __useAppSessionCreateProjectViewMutation__
 *
 * To run a mutation, you first call `useAppSessionCreateProjectViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppSessionCreateProjectViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appSessionCreateProjectViewMutation, { data, loading, error }] = useAppSessionCreateProjectViewMutation({
 *   variables: {
 *      hexId: // value for 'hexId'
 *      hexVersionId: // value for 'hexVersionId'
 *      appSessionId: // value for 'appSessionId'
 *      isSnapshot: // value for 'isSnapshot'
 *      isLogicView: // value for 'isLogicView'
 *      isNotionEmbed: // value for 'isNotionEmbed'
 *      appSessionSpecified: // value for 'appSessionSpecified'
 *      parameterized: // value for 'parameterized'
 *      inAppReferrer: // value for 'inAppReferrer'
 *      inAppReferrerSource: // value for 'inAppReferrerSource'
 *   },
 * });
 */
export function useAppSessionCreateProjectViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AppSessionCreateProjectViewMutation,
    AppSessionCreateProjectViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AppSessionCreateProjectViewMutation,
    AppSessionCreateProjectViewMutationVariables
  >(AppSessionCreateProjectViewDocument, options);
}
export type AppSessionCreateProjectViewMutationHookResult = ReturnType<
  typeof useAppSessionCreateProjectViewMutation
>;
export type AppSessionCreateProjectViewMutationResult =
  Apollo.MutationResult<AppSessionCreateProjectViewMutation>;
export type AppSessionCreateProjectViewMutationOptions =
  Apollo.BaseMutationOptions<
    AppSessionCreateProjectViewMutation,
    AppSessionCreateProjectViewMutationVariables
  >;
